// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"a037c931","177":"fb098330","489":"af126a6e","807":"114262c3","899":"c784a8fe","900":"8802484d"}[chunkId] + ".chunk.js";
};